import React from 'react';
import Breadcrumb from '../components/common/Breadcrumb';

const TermsPage = () => {
  return (
    <div className="bg-white min-h-screen py-8">
      <div className="container mx-auto px-4 md:px-8 max-w-4xl">
        <div className="border-b pb-4 mb-8">
          <Breadcrumb items={[{ label: 'Home', path: '/' }, { label: 'Terms of Service', path: '/terms' }]} />
        </div>
        <h1 className="text-3xl font-light text-center text-gray-900 mb-8 tracking-wide">Terms of Service</h1>
        <div className="space-y-4 text-gray-700 text-sm leading-relaxed">
          <p>Last Updated: June 15, 2026</p>
          <p>By using ArshiVastra, you agree to these terms. Please read them carefully.</p>
          <p><strong>Acceptance of Terms:</strong> By accessing our website, you accept these terms and agree to comply with all applicable laws.</p>
          <p><strong>Use of Website:</strong> You may use our website only for lawful purposes. You must not use it in any way that could damage or impair the site.</p>
          <p><strong>Orders and Payments:</strong> All orders are subject to availability. We reserve the right to cancel any order for any reason.</p>
          <p><strong>Limitation of Liability:</strong> ArshiVastra shall not be liable for any indirect, incidental, or consequential damages arising from the use of our products or website.</p>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;